<template>
      <div>
        <b-icon icon="x-octagon" variant="danger" animation="throb" font-scale="8" />
        <hr>
        <h3 class="mb-0">  Süresi Bitmiş Abonelik </h3>

        <p> 
            <strong> {{data.customer_sub ? data.customer_sub.subscription_name : data.sub.name}} </strong> aboneliğinin bakım süresi <strong> {{dateFormat(data.customer_sub ? data.customer_sub.end_date : data.end_date)}} </strong>
            tarihinde sona ermiş. Lütfen müşteriye aboneliğinin bakım süresinin dolduğu konusunda bilgilendirme yapınız. Lütfen bakımı biten kullanıcılara 
            destek vermeyiniz.
        </p>
   </div>
</template>

<script>
import moment from 'moment'

    export default {
        name: "Expired",
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalEvent: Function,
            modalName: String
        },
         watch: {
            save: async function(data){
                this.saveState(false)
                this.modalEvent(false)
            }
        },
        methods: {
            dateFormat(date){
                return moment(date).format('DD MMMM YYYY dddd')
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Support/Ticket/modals/ExpiredSubs.vue